module.exports = __webpack_public_path__ + "static/media/loading.bdd73c7c.svg";